import React from 'react';

interface Props {
    message?: string;
    icon?: string;
}

const ErrorMessage = ({ message, icon = 'ikon-utropstegn-24' }: Props): JSX.Element => (
    <div className="error-message">
        <i className={`error-icon ${icon}`} />
        {message}
    </div>
);

export default ErrorMessage;
